import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useReduxState } from "../../../../explorer/redux/hooks";
import { Machine } from "../../../../explorer/types/SpareParts";
import { BomItem } from "../../../../explorer/types/SpareParts/BomItem";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";
import useGoToPage from "../../../hook/useGoToPage";
import { useTreeLayoutClasses } from "./TreeLayout.style";
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { TreeItem2, TreeItem2Props, TreeItem2SlotProps } from "@mui/x-tree-view/TreeItem2";
import { useTreeItem2 } from "@mui/x-tree-view/useTreeItem2";
import { useTreeItem2Utils } from "@mui/x-tree-view/hooks/useTreeItem2Utils/useTreeItem2Utils";
import { useParams } from "react-router";

type TTreeLayout = {
    items: BomItem[];
    currentMachine: Machine;
    currentNaturalKey: string;
}

const TreeLayout = (props: TTreeLayout) => {

    const [expandedItems, setExpandedItems] = useState<string[]>([]);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const [naturalKey, setNaturalKey] = useReduxState<string>(reduxStoreConfig.sparePartsCurrentNaturalKey);

    const goToPage = useGoToPage();

    const handleExpandedItemsChange = (event: React.SyntheticEvent | null, itemIds: string[]) => {
        setExpandedItems(itemIds);
    };

    const handleSelectedItemsChange = (event: React.SyntheticEvent, itemIds: string[] | null) => {
        setSelectedItems(itemIds!);
    }

    useEffect(() => {
        openTreeView(props.currentNaturalKey);
    }, [props.currentNaturalKey, props.items])

    // salvato su Redux → al click del OpenNextLevelComponent
    useEffect(() => {
        if (naturalKey !== "")
            openTreeView(naturalKey);
    }, [naturalKey])

    const openTreeView = (nk: string) => {
        let expItems: string[] = [];
        const selItems: string[] = [];

        const items = props.items.map(x => x.id);
        const keys = nk.split('/');

        for (let i = 0; i < keys.length; i++) {
            expItems.push(keys.slice(0, i + 1).join('/'));
            selItems.push(keys.slice(0, i + 1).join('/'));
        }

        const currentNode = props.items.find(n => n.id);
        if(currentNode && currentNode.level === 1) {
            expItems = expItems.concat(currentNode.children?.map(n => n.id) ?? []);
        } 
        expandedItems.forEach((ei: string) => {
            expItems.push(ei);
        })

        items.forEach(id => {
            expItems.push(id);
        });

        setExpandedItems(expItems);
        setSelectedItems(selItems);

        setNaturalKey("");
    }

    const handleClickRow = (event: React.SyntheticEvent, itemId: string) => {
        // Deve essere schiacciata la label e basta, non deve ricaricarsi la pagina se schiacciata la freccia
        if (event) {
            const target: EventTarget = event.target;

            // Se si schiaccia sul Div mi ricarica la pagina e 
            if (target instanceof HTMLDivElement) {
                // Se si rischiaccia lo stesso itemId, deve mantenere il colore sui parent.
                setNaturalKey(itemId);
                goToPage.spareParts.goToMachine(
                    props.currentMachine.customerSiteCode!,
                    props.currentMachine.id!.toString(),
                    itemId
                );
            }
            /* Se si schiaccia sulla freccia di apertura del Tree, non deve ricaricare niente,
             * ma deve mantenere selezionati quelli della NaturalKey
            */
            else {
                const ids: string[] = [];
                const keys = props.currentNaturalKey.split('/');

                for (let i = 0; i < keys.length; i++) {
                    ids.push(keys.slice(0, i + 1).join('/'));
                }

                setTimeout(() => {
                    setSelectedItems(ids);
                }, 10);
            }
        }
    }


    const classes = useTreeLayoutClasses();

    return (
        <Box>
            <RichTreeView
                items={props.items}
                expansionTrigger="iconContainer"
                onItemClick={handleClickRow}
                expandedItems={expandedItems}
                onExpandedItemsChange={handleExpandedItemsChange}
                selectedItems={selectedItems}
                onSelectedItemsChange={handleSelectedItemsChange}
                multiSelect={true}
                sx={classes.root}
                slots={{ item: CustomTreeItem }}
            />
        </Box>
    )
}

/* usiamo un nodo custom per colorarlo di blu se e' quello selezionato */
const CustomTreeItem = React.forwardRef(function CustomTreeItem(
  props: TreeItem2Props,
  ref: React.Ref<HTMLLIElement>
) {
  const classes = useTreeLayoutClasses();
  const params = useParams();
  const parentNaturalKey = params["*"];
  var mySx = parentNaturalKey === props.itemId ? classes.selected : {};
  return (
    <TreeItem2
      {...props}
      ref={ref}
      slotProps={
        {
          label: {
            sx: mySx,
          },
        } as TreeItem2SlotProps
      }
    />
  );
});

export default TreeLayout;
